import CollapsibleContent from '../CollapsibleContent';
import React from 'react';
import {EventSeriesProps} from '../../../pages/calendar/types/eventModel';
import {EventFullInfo} from '../../../../models/event';
import {EventFormModal} from '../../../pages/calendar/components/EventFormModal';
import moment from 'moment';
import {useNavigate} from "react-router-dom";

interface CollapsibleHostControlProps {
    title: string,
    startingIsCollapsed: boolean,
    loggedInUser: number,
    authToken: string,
    event: EventFullInfo,
}

const CollapsibleHostControl = (props: CollapsibleHostControlProps) => {
    const navigate = useNavigate();

    const timeZone = moment.tz.guess();

    const [hostControlDialog, setHostControlDialog] = React.useState<boolean>(false);
    const [series, setSeries] = React.useState<EventSeriesProps>()
    

    const enableHostControlDialog = () => {
        setHostControlDialog(true);
    }

    React.useEffect(()=> {
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
        }

        console.log(props.event);

        if (!props.event.series_ID) {
            return
        }

        fetch(process.env.REACT_APP_REFLEBULA + `/a1/tga/event2/series?id=${props.event.series_ID}`, requestOptions)
            .then(res => res.json())
            .then((res) => {
                if (res.result && res.result === `success`) {
                    console.log(res.data);
                    const start = moment(res.data.event_start_time,'HH:mm').tz(timeZone)
                    const end = moment(res.data.event_end_time,'HH:mm').tz(timeZone)
                    const ser = {
                        ...res.data,
                        eventsStart: moment(res.data.events_start).tz(timeZone).toDate(),
                        eventsEnd: moment(res.data.events_end).tz(timeZone).toDate(),
                        eventStartTime: start.clone().tz('GMT').toDate(),
                        eventEndTime: end.clone().tz('GMT').toDate(),
                        highestTableNumber: res.data.highest_table_number,
                        lowestTableNumber: res.data.lowest_table_number,
                        recurrencePattern: res.data.recurrence_pattern,
                        recurrenceSeperation: res.data.recurrence_seperation

                    }
                    console.log(ser);
                    setSeries(ser);
                    return;
        
                } else {
                    console.error(`Backend Error in SetEvent`);
                    console.error(res)
                    res.reason && console.error(`Reason: ${res.reason}`);
                    return;
                }
            })
            .catch((reason) => {
                console.error('Fetch Exception in SetEvent')
                console.error(`Reason: ${reason}`)
                return;
            })
    },[props.event.series_ID])

    const fakeRsvpToggle = (eid: number) =>
    {
        //Hackiness for now
        return Promise.resolve(false);
    }

    const handleOnSuccessfulSubmission = () => 
    {
        setHostControlDialog(false);
    }

    // TODO: add this back into the EventFormModal tag below => series={series}
    
    return(
        <div>
            <CollapsibleContent title={props.title} startingIsCollapsed={props.startingIsCollapsed}>
                <button onClick={() => enableHostControlDialog()}>To Event Host Panel</button>
            </CollapsibleContent>
            <dialog style={{zIndex:20, height:'75%', position:'absolute', top:100, width:'60%'}} open={hostControlDialog}>
                
            
                <EventFormModal
                    onCancel={()=>setHostControlDialog(false)}
                    event={props.event}
                    loggedInUser={props.loggedInUser} 
                    authToken={props.authToken}
                    onRSVPToggle={fakeRsvpToggle}
                    onSubmitSuccessful={handleOnSuccessfulSubmission}
                    readonly={false}
                    disableRsvp={true}
                    noReset={true}
                />
            </dialog>
        </div>
    )
}

export default CollapsibleHostControl;